import React from "react";
import Flute from "../../assets/back/flute.svg";
import Drum from "../../assets/back/drum.svg";
import Dhapli from "../../assets/back/dhapli.svg";
import Keyboard from "../../assets/back/keyboard.svg";
import Organ from "../../assets/back/organ.svg";
import styles from "./AboutUs.module.css";

const Background = () => {
  return (
    <div className={styles.background_t}>
      <div className={styles.background_main}>
        <div className={styles.background_a}>
          <img src={Flute} alt="flute" className={styles.back_common} />
          <img src={Drum} alt="flute" className={styles.back_common} />
          <img src={Dhapli} alt="flute" className={styles.back_common} />
          <img src={Keyboard} alt="flute" className={styles.back_common} />
          <img src={Organ} alt="flute" className={styles.back_common} />
          <img src={Flute} alt="flute" className={styles.back_common} />
          <img src={Drum} alt="flute" className={styles.back_common} />
          <img src={Dhapli} alt="flute" className={styles.back_common} />
          <img src={Keyboard} alt="flute" className={styles.back_common} />
          <img src={Organ} alt="flute" className={styles.back_common} />
        </div>
        <div className={styles.background_a}>
          <img src={Flute} alt="flute" className={styles.back_common} />
          <img src={Drum} alt="flute" className={styles.back_common} />
          <img src={Dhapli} alt="flute" className={styles.back_common} />
          <img src={Keyboard} alt="flute" className={styles.back_common} />
          <img src={Organ} alt="flute" className={styles.back_common} />
          <img src={Flute} alt="flute" className={styles.back_common} />
          <img src={Drum} alt="flute" className={styles.back_common} />
          <img src={Dhapli} alt="flute" className={styles.back_common} />
          <img src={Keyboard} alt="flute" className={styles.back_common} />
          <img src={Organ} alt="flute" className={styles.back_common} />
        </div>
      </div>
      <div className={styles.background_main_b}>
        <div className={styles.background_b}>
          <img src={Drum} alt="flute" className={styles.back_common} />
          <img src={Dhapli} alt="flute" className={styles.back_common} />
          <img src={Flute} alt="flute" className={styles.back_common} />
          <img src={Keyboard} alt="flute" className={styles.back_common} />
          <img src={Organ} alt="flute" className={styles.back_common} />
          <img src={Drum} alt="flute" className={styles.back_common} />
        </div>
        <div className={styles.background_b} style={{ alignItems: "flex-end" }}>
          <img src={Flute} alt="flute" className={styles.back_common} />
          <img src={Drum} alt="flute" className={styles.back_common} />
          <img src={Dhapli} alt="flute" className={styles.back_common} />
          <img src={Keyboard} alt="flute" className={styles.back_common} />
          <img src={Organ} alt="flute" className={styles.back_common} />
          <img src={Flute} alt="flute" className={styles.back_common} />
        </div>
      </div>
    </div>
  );
};

export default Background;
